<template>
  <div>
    <div v-for="(item,index) in smallData" style="position: relative;">
      <div style="height: 48px;line-height: 48px;margin-bottom: 5px;">
        <span style="color: red;margin-top: 5px;">
          *
        </span>
        <el-input :disabled="skudisable[index]" v-model="skuPricesInput[index]" placeholder="请输入" size="small" type="number" @blur="priceBlur" style="width: 120px;margin-right: 16px;"></el-input>
        <el-button type="text" v-if="item.deleteFlag == 1" @click="closeDeleteShow(index,item,0,smallData)">监控</el-button>
        <el-button type="text" v-if="item.deleteFlag == 0" @click="closeDeleteShow(index,item,1,smallData)">取消监控</el-button>
        <span class="g-inline-block" v-show="index == 0" @click="smallbatchPrice(index,smallData)" style="margin-left: 16px;color: #108cee;cursor: pointer;">批量填价</span>
      </div>
    </div>
    <el-dialog
      title="批量填价"
      :visible.sync="smallshopPrice"
      :close-on-click-modal="false"
      width="640px"
      id="dialog">
      <el-row style="box-sizing: border-box;max-height: 595px;overflow:auto;">
        <div class="seaerch-wrapper">
          <el-form label-width="100px">
            <el-form-item label="批量填价" :required="true">
              <el-input placeholder="请输入" v-model="smallfillPrice" size="small" type="number"></el-input>
            </el-form-item>
          </el-form>
        </div>
      </el-row>
      <span slot="footer">
        <el-button size="small" type="primary" @click="smallpriceSure">确 定</el-button>
        <el-button size="small" type="TheCustom" @click="smallshopPrice = false">取 消</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  export default {
    props: {
      smallData: Array,
      smallIndex: Number,
    },
    name: 'smallTable',
    data() {
      return {
        skuPricesInput: [],
        skudisable: [],
        smallfillPrice: '',
        smallshopPrice: false,
        DeleteIndex: '',
        DeleteItem: '',
        deleType: '',
      }
    },
    methods: {
      smallbatchPrice(index,smallData) {
        this.smallshopPrice = true
      },
      // 是否进行监控
      closeDeleteShow(index,item,deleType,smallData) {
        this.DeleteIndex = index
        this.DeleteItem = item
        this.deleType = deleType
        this.smallData[index].deleType = deleType
        this.closeDel(smallData)
      },
      closeDel(smallData) {
        for (let c in smallData) {
          this.skudisable.push(false)
        }
        let params={
          skuid: this.DeleteItem.id,
          type: this.deleType
        }
        fetch({
          url: "hcm/monitorLink/deleteNewMonitorSku",
          method: "get",
          params: params,
          noFormat: true,
          responseType: "text"
        }).then(result => {
          let res = JSON.parse(result);
          let {data}=res
          if(res.status == '10000'){
            if (this.deleType == 0) {
              this.$set(this.skudisable,this.DeleteIndex,false);
              smallData[this.DeleteIndex].deleteFlag = 0
            } else {
              this.$set(this.skudisable,this.DeleteIndex,true);
              smallData[this.DeleteIndex].deleteFlag = 1
              this.skuPricesInput[this.DeleteIndex] = 0
            }
          }
        }).catch(err => {

        })
      },
      smallpriceSure() {
        this.skuPricesInput = []
        for (let a in this.smallData) {
          if (this.skudisable[a] == true) {
            this.skuPricesInput.push(0)
          } else {
            this.skuPricesInput.push(this.smallfillPrice)
          }
          this.skudisable.push(false)
        }
        this.smallshopPrice = false
        this.priceBlur()
      },
      priceBlur() {
        let data ={
          skuPricesInput: this.skuPricesInput,
          index: this.smallIndex
        }
        this.$emit('tableClick', data)
      }
    },
  }
</script>
<style lang="scss">


</style>
